import React, { FunctionComponent } from "react"
import PureImage from "../../components/Image/PureImage"
import { iArtifact } from "../../definitions/Artifacts"
import { eImageVersions } from "../../definitions/Image"
import { useImageUrl } from "../../hooks/useImageUrl"

const ArtifactItem: FunctionComponent<iArtifact> = ({
  title,
  culture,
  previewVersions,
}) => {
  const url =
    previewVersions && useImageUrl(eImageVersions.LIcon, previewVersions)

  return (
    <div className="content-item">
      <div className="content-image">
        <PureImage src={url} />
      </div>
      <div className="content-block">
        <h3>{title}</h3>
        <span>{culture}</span>
      </div>
    </div>
  )
}

export default ArtifactItem
